import { render, staticRenderFns } from "./withdrawal.vue?vue&type=template&id=6e408b06&scoped=true&"
import script from "./withdrawal.vue?vue&type=script&lang=js&"
export * from "./withdrawal.vue?vue&type=script&lang=js&"
import style0 from "./withdrawal.vue?vue&type=style&index=0&id=6e408b06&prod&lang=less&scoped=true&"
import style1 from "./withdrawal.vue?vue&type=style&index=1&id=6e408b06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e408b06",
  null
  
)

export default component.exports